import { render, staticRenderFns } from "./Book-Lesson-choose-type.vue?vue&type=template&id=764b7d66&scoped=true"
import script from "./Book-Lesson-choose-type.vue?vue&type=script&lang=js"
export * from "./Book-Lesson-choose-type.vue?vue&type=script&lang=js"
import style0 from "./Book-Lesson-choose-type.vue?vue&type=style&index=0&id=764b7d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764b7d66",
  null
  
)

export default component.exports